export const api =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8081/SISARMA-SOCIO/api/'
    : 'https://appdemo.sisarma.com.br/api/'

console.log('🚀 ~ api: ', api)
